import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { SectionHeading, Desc, SettingRow, LabelTitle, LabelDesc, Control, StyledSelect } from '../shared/primitives';
import styles from './ArmingModesSection.module.css';

type ArmModeKey = 'disarmed' | 'armStay' | 'armAway' | 'armNight';

const ARM_MODE_KEYS: ArmModeKey[] = ['disarmed', 'armStay', 'armAway', 'armNight'];
const BEHAVIOR_OPTION_KEYS = ['none', 'default', 'privacyMode'] as const;

const DEFAULT_BEHAVIORS: Record<ArmModeKey, string> = {
  disarmed: 'none',
  armStay:  'privacyMode',
  armAway:  'privacyMode',
  armNight: 'default',
};

const ArmingModesSection: React.FC<{ onBehaviorChange?: (key: ArmModeKey, value: string) => void }> = ({ onBehaviorChange }) => {
  const { t } = useTranslation();
  const [behaviors, setBehaviors] = useState<Record<ArmModeKey, string>>({ ...DEFAULT_BEHAVIORS });

  return (
    <>
      <SectionHeading>{t('bulkEditSettings.armingModes.heading')}</SectionHeading>
      <Desc>{t('bulkEditSettings.armingModes.description')}</Desc>
      {ARM_MODE_KEYS.map((key) => {
        const label = t(`bulkEditSettings.armingModes.modes.${key}.label`);
        const description = t(`bulkEditSettings.armingModes.modes.${key}.description`);
        return (
          <SettingRow key={key}>
            <div>
              <LabelTitle>{label}</LabelTitle>
              {description && <LabelDesc>{description}</LabelDesc>}
            </div>
            <Control>
              <div className={styles.behaviorField}>
                <span className={styles.behaviorLabel}>
                  {t('bulkEditSettings.armingModes.deterrenceBehaviorLabel')}
                </span>
                <StyledSelect
                  name={`deterrence-${key}`}
                  value={behaviors[key]}
                  onChange={e => {
                    const value = e.target.value;
                    setBehaviors(p => ({ ...p, [key]: value }));
                    onBehaviorChange?.(key, value);
                  }}
                >
                  {BEHAVIOR_OPTION_KEYS.map(opt => (
                    <option key={opt} value={opt}>
                      {t(`bulkEditSettings.armingModes.behaviorOptions.${opt}`)}
                    </option>
                  ))}
                </StyledSelect>
              </div>
            </Control>
          </SettingRow>
        );
      })}
    </>
  );
};

export default ArmingModesSection;
